<div *ngIf="errorMessage" class="error-alert-box-container">
	<div class="error-alert-box grid-column-one-full card-block">
		<button type="button" mat-icon-button class="close-button" mat-ripple (click)="evtCancel()">
			<mat-icon svgIcon="md:close"></mat-icon>
		</button>
		<div *ngIf="errorMessage" class="card-infos copo-notification-block copo-notification-message-line">
			<mat-icon svgIcon="alert" [attr.title]="'quapp.alert' | translate" class="copo-notification-icon"></mat-icon>
			<div class="error-message">
				<div class="error-alert-title" translate>{{errorTitle}}</div>
				<div *ngIf="errorMessage" class="error-alert-description">{{ errorMessage }}</div>		
			</div>
		</div>
	</div>
</div>